<table class="attention" *ngIf="rows && rows.length > 0">
  <thead>
    <tr>
      <th scope="col">{{ 'dashboard.team.member' | translate }}</th>
      <th scope="col">{{ 'dashboard.company.col_signal' | translate }}</th>
      <th scope="col">{{ 'dashboard.company.col_detail' | translate }}</th>
      <th scope="col">{{ 'dashboard.company.col_date' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows" class="attention-row">
      <td class="name" [attr.data-label]="'dashboard.team.member' | translate"><button type="button" class="row-action" (click)="select(row, $event)">{{ row.name }}</button></td>
      <td [attr.data-label]="'dashboard.company.col_signal' | translate">
        <span class="sig">{{ ('dashboard.company.signal_' + row.signal) | translate }}</span>
        <span class="chip" [class.chip-high]="row.severity === 'high'" [class.chip-med]="row.severity === 'med'">{{ ('dashboard.company.sev_' + row.severity) | translate }}</span>
      </td>
      <td class="detail" [attr.data-label]="'dashboard.company.col_detail' | translate">{{ row.detail }}</td>
      <td class="date" [attr.data-label]="'dashboard.company.col_date' | translate">{{ row.date ? (row.date | date:'d MMM y') : '—' }}</td>
    </tr>
  </tbody>
</table>
<div class="attention-empty" *ngIf="rows && rows.length === 0">{{ 'dashboard.company.attention_empty' | translate }}</div>
